<template>
  <vue-apex-charts
    class="istTreeChart"
    ref="refInsightChartTree"
    height="300"
    width="100%"
    :options="chartOptionsTree"
    :series="series"
  />
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  name: "InsightChartTree",
  components: {
    VueApexCharts,
  },
  data() {
    return {
      chartOptionsTree: {
        chart: {
          type: "treemap",
          height: 350,
          toolbar:{
            show: false
          },
        },
        dataLabels: {
          enabled: true,
          fontFamily: "NanumBarunGothic !important",
        },
        legend: {
          show: false,
        },
        colors: [
          '#7C4D7A'
        ],
        states: {  // Tree Map 클릭 및 마우스 호버에 대한 이벤트를 제한하기 위함함
          active: {
            filter: {
              type: 'none' /* none, lighten, darken */
            }
          },
          hover: {
            filter: {
              type: 'none' /* none, lighten, darken */
            }
          },
        },
      },
      series: [
        {
          data: []
        }
      ],
    };
  },
  props: {
    treeChartData: {
      type: Array,
      default: () => [],
    },
    treeChartGubun:{
      type: String,
      required: true
    }
  },
  watch: {
    treeChartData() {
      const newData = [];

      for (const data of this.treeChartData) {
        newData.push(data);
      }

      this.setValues(newData);
    },
  },

  methods:{
    setValues(newData){
      this.chartOptionsTree = {
        ...this.chartOptionsTree,
        ...{
            dataLabels: {
              enabled: true,
              textAnchor: 'middle',
              position: 'center',
              style: {
                colors: ['#fff'],
                fontFamily: "NanumBarunGothic !important",
                fontSize: "16px",
              },
              formatter: function (val, opt) {
                if(newData[opt.dataPointIndex]){
                  if (newData[opt.dataPointIndex].x.length >5){
                    return [newData[opt.dataPointIndex].x.substring(0,5)+'...', newData[opt.dataPointIndex].y + '%']
                  }else{
                    return [newData[opt.dataPointIndex].x, newData[opt.dataPointIndex].y + '%']
                  }
                }else{
                  return val
                }
              },
              dropShadow: {
                enabled: false
              },
              offsetX: 0,
              offsetY: -5,
            }, 
            tooltip: {
              followCursor: true,
              x: {
                show: false
              },
              y: {
                formatter: function (val, opt) {
                  if(newData[opt.dataPointIndex]){
                    return newData[opt.dataPointIndex].x + ' : ' + parseFloat(newData[opt.dataPointIndex].freq).toLocaleString() + '(' + newData[opt.dataPointIndex].y + '%)' 
                  }else{
                    return val
                  }                    
                },
                title: {
                  formatter: function () {
                    return ''
                  }
                },
              },
              marker: {
                  show: false,
              },
            },   
            series: [{
              data: newData
            }],    
          }
      }
    }
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/chart-apex.scss";

.istTreeChart .apexcharts-canvas .apexcharts-tooltip-text {
  font-family: NanumBarunGothic !important;
  font-weight: 400;
  font-size: 10px !important;
  filter: none;
}

</style>
